// extracted by mini-css-extract-plugin
export var container = "index-module--container--1VURB";
export var dismissButton = "index-module--dismissButton--3QaHl";
export var containerMobile = "index-module--containerMobile--1aV_r";
export var announcmentText = "index-module--announcmentText--2irUw";
export var icon = "index-module--icon--3Fcd9";